import EventBus from '@/event-bus'
import aiBuddySections from '@/data/aiBuddySections'
import { mapGetters } from 'vuex'

export default {

  computed: {
    ...mapGetters('idea', ['getBusinessPlanSectionByName']),
    ...mapGetters('ui', ['getLoaders']),

    aiBuddyLoader () {
      return this.getLoaders.aiBuddy
    },

    aiTemplateLoader () {
      return this.getLoaders.aiTemplate
    },

    stepsData () {
      return {
        productGuide: {
          type: 'product',
          suggestionsTemplate: true
        },
        promotionGuide: {
          type: 'promotion',
          suggestionsTemplate: true
        },
        distributionGuide: {
          type: 'distribution',
          suggestionsTemplate: true
        },
        partnerGuide: {
          type: 'partners',
          suggestionsTemplate: true
        },
        ideaGuide: {
          type: 'idea',
          suggestionsTemplate: false
        },
        customerGuide: {
          type: 'customers',
          suggestionsTemplate: true
        },
        marketGuide: {
          type: 'market',
          suggestionsTemplate: false
        },
        marketPotentialGuide: {
          type: 'market-potential',
          suggestionsTemplate: false
        },
        competitorGuide: {
          type: 'competitors',
          suggestionsTemplate: true
        },
        swotAnalysisGuide: {
          type: 'swot-analysis',
          suggestionsTemplate: false
        },
        managementTeamGuide: {
          type: 'managementTeam',
          suggestionsTemplate: false
        },
        ownershipGuide: {
          type: 'ownership',
          suggestionsTemplate: false
        },
        startupCostGuide: {
          type: 'startup-costs',
          suggestionsTemplate: true
        },
        startupCostFinancialPlanGuide: {
          type: 'startup-costs',
          suggestionsTemplate: true
        },
        staffPayrollGuide: {
          type: 'staff-and-payroll',
          suggestionsTemplate: true
        },
        staffPayrollFinancialPlanGuide: {
          type: 'staff-and-payroll',
          suggestionsTemplate: true
        },
        revenueStreamGuide: {
          type: 'revenue-streams',
          suggestionsTemplate: true
        },
        revenueStreamFinancialPlanGuide: {
          type: 'revenue-streams',
          suggestionsTemplate: true
        },
        directCostGuide: {
          type: 'direct-costs',
          suggestionsTemplate: true
        },
        directCostFinancialPlanGuide: {
          type: 'direct-costs',
          suggestionsTemplate: true
        },
        otherOverheadsGuide: {
          type: 'other-overheads',
          suggestionsTemplate: true
        },
        otherOverheadsFinancialPlanGuide: {
          type: 'other-overheads',
          suggestionsTemplate: true
        },
        marketingBudgetGuide: {
          type: 'marketing-costs',
          suggestionsTemplate: true
        },
        marketingBudgetFinancialPlanGuide: {
          type: 'marketing-costs',
          suggestionsTemplate: true
        },
        ideaPlanGuide: {
          type: 'canvas',
          suggestionsTemplate: true
        }
      }
    }
  },

  methods: {
    async generateTemplateItems (guideStep) {
      const ideaId = this.$store.state.idea.id
      const data = this.stepsData[guideStep]
      if (!data) return

      const { type, suggestionsTemplate } = data
      const isAiBuddy = !!aiBuddySections[type]

      // Show loaders
      if (isAiBuddy) {
        this.$store.commit('ui/setLoader', { key: 'aiBuddy', value: true })
      }
      if (suggestionsTemplate) {
        this.$store.commit('ui/setLoader', { key: 'aiTemplate', value: true })
      }

      // Call AI Buddy API if needed
      if (isAiBuddy) {
        try {
          const { data: { payload: { response } } } = await this.$http.post(
            `ai/help-me-write/ai-buddy/${ideaId}`,
            {
              sectionName: aiBuddySections[type],
              userInput: '',
              template: true
            }
          )
          EventBus.$emit('ai-help-me-write-save', response)
        } finally {
          this.$store.commit('ui/setLoader', { key: 'aiBuddy', value: false })
        }
      }

      // Call Suggestions Template API if needed
      if (suggestionsTemplate) {
        try {
          await this.$http.post(`ai/${type}/ai-template/${ideaId}`)
        } finally {
          this.$store.commit('ui/setLoader', { key: 'aiTemplate', value: false })
        }
      }
    },

    async generateIdeaTemplateItems () {
      this.$store.commit('ui/setLoader', { key: 'aiTemplate', value: true })
      const ideaId = this.$store.state.idea.id

      await Promise.all([
        this.$http.post(`ai/idea-why/ai-template/${ideaId}`),
        this.$http.post(`ai/idea-what/ai-template/${ideaId}`)
      ])
    },

    async generateSwotAnalysisTemplateItems () {
      const ideaId = this.$store.state.idea.id
      this.$store.commit('ui/setLoader', { key: 'aiTemplate', value: true })

      await Promise.all([
        this.$http.post(`ai/swot-strengths/ai-template/${ideaId}`),
        this.$http.post(`ai/swot-weaknesses/ai-template/${ideaId}`),
        this.$http.post(`ai/swot-opportunities/ai-template/${ideaId}`),
        this.$http.post(`ai/swot-threats/ai-template/${ideaId}`)
      ])
    }
  }
}
